import ScheduleHeader from "./ScheduleHeader";
import ScheduleBody from "./ScheduleBody";
import Legend from "./Legend";

const Schedule = (props) => {
  const { event, categories, rooms, schedule } = props.config;

  return (
    <>
      <table id="schedule">
        <ScheduleHeader rooms={rooms} />
        <ScheduleBody
          startTime={event.startTime}
          endTime={event.endTime}
          breakStart={event.breakStart}
          breakEnd={event.breakEnd}
          rooms={rooms}
          schedule={schedule}
          categories={categories}
        />
      </table>
      <Legend categories={categories} />
    </>
  );
};

export default Schedule;
